import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'telxl-modal',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.scss',
})
export class TelXLModalComponent {
    readonly #modalService = inject(NgbModal);

    @ViewChild('modalTemplate', { static: true })
    modalTemplate!: TemplateRef<any>;

    title = input.required<string>();

    open(size: 'sm' | 'lg' | 'xl' = 'lg') {
        this.#modalService.open(this.modalTemplate, {
            backdrop: 'static',
            size,
        });
    }

    close() {
        this.#modalService.dismissAll();
    }
}
